import Term from "./Term";
import { About } from "./About";
import { Projects } from "./Projects";
import { Contact } from "./Contact";

export function Home({ navLinks }: { navLinks: { path: string; label: string }[] }) {
  return (
    <div className="flex flex-col items-center gap-4">
      <div className="pt-24 w-full flex justify-center " id="home"><Term navLinks={navLinks} /></div>
      <div className="pt-10" id="about"><About /></div>
      <div className="pt-10" id="projects"><Projects /></div>
      <div className="pt-10" id="contact"><Contact /></div>
    </div>
  );
}
